var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAudit7(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "190.000000pt",
    height: "190.000000pt",
    viewBox: "0 0 190.000000 190.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,190.000000) scale(0.100000,-0.100000)",
    fill: "#D00202",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1331 1610 c-98 -24 -162 -140 -131 -235 40 -122 177 -167 285 -94 105 73 99 244 -12 306 -46 26 -97 34 -142 23z m120 -52 c41 -23 79 -84 79 -128 0 -45 -40 -109 -81 -130 -104 -54 -219 14 -219 130 0 117 119 186 221 128z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1360 1535 c0 -8 -5 -15 -10 -15 -6 0 -15 -11 -21 -24 -14 -30 2 -63 37 -76 52 -20 37 -66 -18 -54 -21 4 -28 2 -28 -10 0 -9 8 -16 20 -16 11 0 23 -7 26 -15 7 -18 24 -20 24 -2 0 7 9 18 20 25 13 8 20 23 20 42 0 23 -7 33 -32 46 -18 9 -36 22 -40 28 -11 17 13 38 39 31 16 -4 23 -1 23 10 0 8 -7 15 -15 15 -8 0 -15 7 -15 15 0 8 -7 15 -15 15 -8 0 -15 -7 -15 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1163 1142 c-54 -43 -103 -81 -109 -85 -7 -4 -72 18 -145 49 -74 30 -141 53 -149 51 -30 -8 -300 -208 -300 -223 0 -8 5 -14 10 -14 6 0 74 45 150 100 77 55 145 100 150 100 5 0 71 -25 145 -56 92 -38 140 -53 148 -47 115 90 213 169 219 177 8 12 1 26 -12 26 -5 0 -53 -35 -107 -78z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1267 1113 c-4 -3 -7 -143 -7 -310 l0 -303 -35 0 -35 0 0 205 0 205 -115 0 -115 0 0 -205 0 -205 -40 0 -40 0 -2 223 -3 222 -105 0 -105 0 -3 -222 -2 -223 -40 0 -40 0 0 160 0 160 -115 0 -115 0 0 -160 0 -160 -54 0 c-55 0 -81 -15 -55 -31 18 -11 1340 -11 1358 0 26 16 0 31 -55 31 l-54 0 0 310 0 310 -108 0 c-60 0 -112 -3 -115 -7z m191 -320 l2 -293 -80 0 -80 0 0 295 0 296 78 -3 77 -3 3 -292z m-608 -88 l0 -205 -80 0 -80 0 0 205 0 205 80 0 80 0 0 -205z m300 -15 l0 -190 -75 0 -75 0 0 190 0 190 75 0 75 0 0 -190z m-610 -45 l0 -145 -75 0 -75 0 0 145 0 145 75 0 75 0 0 -145z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudit7);
export default __webpack_public_path__ + "static/media/audit-7.c5e6dffea4b4b2dd8579861b8ffc34f6.svg";
export { ForwardRef as ReactComponent };